import { render, staticRenderFns } from "./TabSolicitacao.vue?vue&type=template&id=00069f1e&"
import script from "./TabSolicitacao.vue?vue&type=script&lang=js&"
export * from "./TabSolicitacao.vue?vue&type=script&lang=js&"
import style0 from "./TabSolicitacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports